// extracted by mini-css-extract-plugin
module.exports = {"goBack":"article-module--go-back--zKWfU","toContact":"article-module--to-contact--1lin5"};